/*
 * Valenor — Mobile sticky ATC visibility.
 * Hides .vln-sticky-atc when the hero ATC button is in viewport (so it only
 * appears once the shopper has scrolled past the main CTA) and when the
 * checkout/final CTA is visible (redundant there too).
 */
(() => {
  if (typeof window === 'undefined' || window.__vlnStickyInit) return;
  window.__vlnStickyInit = true;

  const init = () => {
    const sticky = document.querySelector('.vln-sticky-atc');
    if (!sticky) return;
    const triggers = Array.from(
      document.querySelectorAll(
        '.vln-product-hero .vln-btn--atc, .vln-final-cta .vln-btn'
      )
    );
    if (!triggers.length || !('IntersectionObserver' in window)) {
      sticky.removeAttribute('data-hidden');
      return;
    }

    const visible = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        }
        if (visible.size > 0) sticky.setAttribute('data-hidden', '');
        else sticky.removeAttribute('data-hidden');
      },
      { threshold: 0.3, rootMargin: '0px 0px -20% 0px' }
    );
    triggers.forEach((t) => io.observe(t));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
